import { useSearchParams } from 'react-router-dom';

import { ForbiddenView } from '../../../components/ForbiddenView';
import { TabsTruot } from '../../../components/shared';
import { useT } from '../../../i18n';
import { maLoi } from '../../../lib/errors';
import { useHanMucTokenAi } from '../../tenant/hooks/useHanMucTokenAi';
import { TabHanMuc } from '../../token-ai/components/TabHanMuc';
import { TabMucSuDung } from '../../token-ai/components/TabMucSuDung';
import { TabNapToken } from '../../token-ai/components/TabNapToken';
import { TheTomTatToken } from '../../token-ai/components/TheTomTatToken';
import { docMucToken, THAM_SO_MUC_TOKEN } from '../../token-ai/nghiep-vu/token-ai';

/**
 * Thẻ Token AI của màn Báo cáo (ADR-0088, ADR-0091, ADR-0123): tóm tắt luôn ở trên, ba mục con Mức sử dụng, Hạn mức, Nạp
 * token nhớ ở `?muc=`. Chỉ token Fox. `BaoCaoView` đã gác quản trị tổ chức; API vẫn tự kiểm (`Caller`), bị từ chối thì
 * báo không có quyền. `tenantId` lấy từ ngữ cảnh đăng nhập, không bao giờ từ URL.
 */
export function TabTokenAi({ tenantId }: { tenantId: string }) {
  const { t } = useT();
  const q = useHanMucTokenAi(tenantId);
  const [thamSo, setThamSo] = useSearchParams();

  const loi = maLoi(q.error);
  if (loi === 'PERMISSION_DENIED' || loi === 'NOT_FOUND') return <ForbiddenView />;

  return (
    <div className="space-y-4">
      <TheTomTatToken q={q} />
      <TabsTruot
        xuongDong
        defaultActiveKey={docMucToken(thamSo.get(THAM_SO_MUC_TOKEN))}
        onChange={(key) =>
          setThamSo(
            (cu) => {
              const moi = new URLSearchParams(cu);
              moi.set(THAM_SO_MUC_TOKEN, key);
              return moi;
            },
            { replace: true },
          )
        }
        items={[
          { key: 'su-dung', label: t('manTokenAi.theSuDung'), children: <TabMucSuDung tenantId={tenantId} /> },
          { key: 'han-muc', label: t('manTokenAi.theHanMuc'), children: <TabHanMuc tenantId={tenantId} /> },
          { key: 'nap-token', label: t('manTokenAi.theNapToken'), children: <TabNapToken tenantId={tenantId} quota={q.data} /> },
        ]}
      />
    </div>
  );
}
